import { useState, ChangeEvent, useEffect } from 'react'
import axios from 'axios'
import { API_URL, config, UserCode, API_IMAGES } from '../components/Include';
import { useSelector, useDispatch } from 'react-redux'
import { Alerts } from '../components/notify';
import './skills.css';
import Select from 'react-select'
import { styles } from '../components/GlobalFunction';
import { useNavigate } from 'react-router-dom';

const Skills = () => {
  const dispatch = useDispatch()
  const student = useSelector((state: any) => state.rootReducer.student);
  const [courses, setCourses] = useState([] as any);
  const [filterContent, setFilterContent] = useState([] as any);
  const [content, setContent] = useState([] as any);
  const navigate = useNavigate();
  const [list, setList] = useState({
    course_code:[] as any,
  });

  const [items, setItems] = useState('');
  const [selectedSkill, setSelectedSkill] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  
  const [errors, setErrors] = useState({
    errorMessage: '',
    is_loading: false
  });

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setItems(value);

    if (value !== '') {
      const filteredItems = content.filter(
        (item: any) => item.title.toLowerCase().includes(value.toLowerCase())
      );
      setFilterContent(filteredItems);
    } else {
      setFilterContent(content);
    }
  };


  const fetchCourses = async()=>{

    let url = API_URL+'/students/courses'
      await  axios.get(url,  config).then((result:any)=>{

        if(Array.isArray(result.data.data)){
        setCourses(result.data.data)
        }
        })
        .catch((error)=>{
         //ErrorModal('oops', error.message)
        })
      }

  const FetchContent = (code: string) => {
    setErrors({ ...errors, is_loading: true });
    const fd = new FormData();

    fd.append('course_code', code);
    fd.append('study_mode', student.study_mode);
    fd.append('student_code', student.code);
    fd.append('faculty', student.faculty);

    const url = API_URL + '/student/application/skills';
    axios.post(url, fd, config)
      .then((response: any) => {
        if (response.data.status === 200) {
         
          const data = response.data.data;

       
          setFilterContent(data);
          setContent(data);

        } else {
          setErrors({ ...errors, is_loading: false, errorMessage: response.data.message });
          setFilterContent([]);
          setContent([]);
              }
      })
      .catch((error) => {
        Alerts('danger', error.message, 'Something went wrong!');
      })
      .finally(() => {
        setErrors({ ...errors, is_loading: false });
      });
  };



  const handleSkillSelect = (skill: any) => {
    setSelectedSkill(skill);
    setShowModal(true);
  };


  const handleVerify = () => {
    if (!selectedSkill) return;
    


    dispatch({
      type:'SET_RECORDS',
      name:'skill',
      data:{course_code: list.course_code, skill: selectedSkill}
  })

navigate('/app/made_payment?ref=' + UserCode)

  };


  // Get slot status class based on remaining slots
  const getSlotStatusClass = (total: number, applied: number) => {
    const remaining = total - applied;
    const percentage = (remaining / total) * 100;
    
    if (percentage <= 25) return 'low';
    if (percentage <= 50) return 'medium';
    return 'high';
  };



  const handleSelect = (option:any, action:any)=>{

      setList({...list, [action.name]:option});
  
    setErrors({...errors, [action.name]:''})

    FetchContent(option.value);
    
       }


  useEffect(() => {
    fetchCourses();
  }, []);
  return (
    <>
      {/* Loading Overlay */}
      {errors.is_loading && (
        <div className='overlay'>
          <img src="/images/loader.svg" alt="loader" />
        </div>
      )}


 <div className="skills-container  mt-4">
        
        <div className="skills-header">
          <h4>
            <i className="fa fa-briefcase me-2"></i> Choose Course
          </h4>
        </div>

        <div className="skills-content" style={{ minHeight:'300px'}}>

        <section className="col-md-12 ">
 
 <div  className="form-group">
     <label className='text-bold mb-2'>Select Course <span className='text-danger'>*</span></label>

 
<Select  options={
              courses&&courses.map((list:any, idx:number)=> {
              return {key:idx, value: list.code, fees:list.fees, label: list.course_title, course_code:list.course_code, session:list.session}
              })} 
              getOptionLabel={option =>`${option.session} ${option.label} - ${option.course_code}`}
onChange={handleSelect}  
name="course_code"
value={list.course_code} 
styles={styles}
/>
</div>

</section>

        </div>
      </div>


      {content.length > 0 ? (
      <div className="skills-container mt-4">
        {/* Skills Header */}
        <div className="skills-header">
          <h4>
            <i className="fa fa-briefcase me-2"></i> Choose Your Skill
          </h4>
          <div className="skills-search">
            <i className="fa fa-search"></i>
            <input 
              type="text" 
              onChange={handleSearch} 
              value={items} 
              placeholder="Search for skills..." 
            />
          </div>
        </div>

        {/* Skills Content */}
        <div className="skills-content">
          {filterContent.length > 0 ? (
            <div className="skills-grid">
              {filterContent.map((skill: any, index: number) => {
               
            const remainingSlots = Number(skill.slot) - Number(skill.applied);
            const slotStatusClass = getSlotStatusClass(Number(skill.slot), Number(skill.applied));
            
                return  remainingSlots>0&&(
                  <div 
                    className="skill-card" 
                    key={index} 
                    onClick={() => handleSkillSelect(skill)}
                  >
                    <div className="skill-image">
                      <img 
                        src={API_IMAGES + '/skill/' + skill.image} 
                        onError={(e) => {
                          (e.target as HTMLImageElement).onerror = null; 
                          (e.target as HTMLImageElement).src = API_IMAGES + '/no.jpg';
                        }} 
                        alt={skill.title} 
                      />
                      <div className={`skill-slots ${slotStatusClass}`}>
                        <i className="fa fa-users"></i> {remainingSlots} slots
                      </div> 
                    </div>
                    <div className="skill-info">
                      <h5 className="skill-title">{skill.title}</h5>
                      <div className="skill-details">
                        <div className="skill-detail">
                          <i className="fa fa-map-marker"></i>
                          <span>Entrepreneurship Development Center</span>
                        </div>
                        <div className="skill-detail">
                          <i className="fa fa-clock-o"></i>
                          <span>07:00AM Daily</span>
                        </div>
                        <div className="skill-detail">
                          <i className="fa fa-calendar"></i>
                          <span>{skill.session || 'Current Session'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="no-skills">
              <i className="fa fa-search"></i>
              <h4>No Skills Found</h4>
              <p>We couldn't find any skills matching your search criteria. Please try a different search term or check back later.</p>
            </div>
          )}
        </div>
      </div>):[]}

{errors.errorMessage?<div className='alert alert-danger'>{errors.errorMessage}</div>:null}






      {/* Confirmation Modal */}
      {showModal && selectedSkill && (
        <div className="modal skill-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fa fa-info-circle"></i> Confirm Skill Selection
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setShowModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="skill-modal-warning">
                  <i className="fa fa-exclamation-triangle"></i>
                  <strong>Important:</strong> You will be redirect to payment page after confirmation.
                </div>
                <p>You are about to select <strong>{selectedSkill.title}</strong> as your skill. Are you sure you want to proceed?</p>
                </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-cancel" 
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-confirm" 
                  onClick={handleVerify}
                >
                  Confirm Selection
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Skills